import { render, staticRenderFns } from "./scale.vue?vue&type=template&id=f4bd5e6c&scoped=true"
import script from "./scale.vue?vue&type=script&lang=js"
export * from "./scale.vue?vue&type=script&lang=js"
import style0 from "./scale.vue?vue&type=style&index=0&id=f4bd5e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bd5e6c",
  null
  
)

export default component.exports